/*
 * The row of buttons at the foot of a dialog or a form (2026-10-18).
 *
 * One order everywhere: the way out first, the action last, the row pushed
 * to the inline end. Half the app put Cancel first and half put Save first,
 * so a hand that learned one place pressed the wrong button in the other.
 * "Inline end" is logical, so in Hebrew the row sits at the left and the
 * action is the leftmost button -- the same reading order, mirrored.
 *
 * A destructive action that is not the point of the surface does not go
 * here: it goes in components/DangerZone.js, away from the way out.
 *
 *   <ActionBar>
 *     <Button onClick={cancel}>{t('common:cancel')}</Button>
 *     <Button variant="primary" onClick={save}>{t('common:save')}</Button>
 *   </ActionBar>
 *
 * `sticky` keeps the bar at the bottom of a scrolling dialog or page, which
 * on a phone is where the thumb is (ObservationWizard and Field Mode already
 * did this by hand).
 */
export default function ActionBar({ sticky = false, children, style, testId }) {
  return (
    <div data-testid={testId} data-sticky={sticky || undefined}
      style={{ ...barStyle, ...(sticky ? stickyStyle : null), ...style }}>
      {children}
    </div>
  );
}

const barStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 10,
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBlockStart: 16,
};

const stickyStyle = {
  position: 'sticky',
  insetBlockEnd: 0,
  background: 'var(--c-surface)',
  paddingBlock: 12,
  borderBlockStart: '1px solid var(--c-border)',
};
